import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import "../tps.css";

const ProcessGuide = () => {
  const [show, setShow] = useState({ reg: false, paper: false });

  const handleShow = (type) => setShow((s) => ({ ...s, [type]: true }));
  const handleClose = (type) => setShow((s) => ({ ...s, [type]: false }));
  const API = process.env.REACT_APP_API_BASE_URL;

  return (
    <>
      <div className="d-flex justify-content-center gap-3 my-4 ">
        <Button variant="secondary p-2" onClick={() => handleShow("reg")}>
          Registration Process Guide
        </Button>
        <Button variant="secondary p-2" onClick={() => handleShow("paper")}>
          Paper Submission Guide
        </Button>
      </div>

      {/* Registration Modal */}
      <Modal show={show.reg} onHide={() => handleClose("reg")} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Registration Process Guide</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: '80vh', padding: 0 }}>
          <iframe
            src={`${API}/uploads/guide/Registration_Process.pdf`}
            title="Registration Guide PDF"
            width="100%"
            height="100%"
            frameBorder="0"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => handleClose("reg")}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Paper Submission Modal */}
      <Modal show={show.paper} onHide={() => handleClose("paper")} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Paper Submission Guide</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: '80vh', padding: 0 }}>
          <iframe
            src={`${API}/uploads/guide/Paper_Submission_Process.pdf`}
            title="Paper Submission Guide PDF"
            width="100%"
            height="100%"
            frameBorder="0"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleClose("paper")}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProcessGuide;
